import React, { useEffect, useState } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaArrowLeft, FaArrowRight, FaQuestionCircle, FaRegQuestionCircle, FaTools } from 'react-icons/fa';
import axios from 'axios';
import Select from "react-select";
import Quill from "quill";
import Table from "quill-table";
import SummernoteEditor from './summernote';

Quill.register("modules/table", Table);

const modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        ["link", "image"],
        ["table"],
        ["clean"],
    ],
};

const formats = [
    "header", "bold", "italic", "underline", "strike",
    "list", "bullet", "indent", "script", "align",
    "link", "image", "table"
];


const QuestionCorrespondance = ({ onChange, initialLeftOptions, initialRightOptions, initialPairs }) => {
    const [leftOptions, setLeftOptions] = useState(
        initialLeftOptions && initialLeftOptions.length > 0
            ? initialLeftOptions
            : [{ id: 1, value: '' }, { id: 2, value: '' }]
    );
    const [rightOptions, setRightOptions] = useState(
        initialRightOptions && initialRightOptions.length > 0
            ? initialRightOptions
            : [{ id: 1, value: '' }, { id: 2, value: '' }]
    );
    const [selectedPairs, setSelectedPairs] = useState(initialPairs || {});

    useEffect(() => {
        if (initialLeftOptions && initialLeftOptions.length > 0) {
            setLeftOptions(initialLeftOptions);
        }
        if (initialRightOptions && initialRightOptions.length > 0) {
            setRightOptions(initialRightOptions);
        }
        if (initialPairs && Object.keys(initialPairs).length > 0) {
            setSelectedPairs(initialPairs);
        }
    }, [initialLeftOptions, initialRightOptions, initialPairs]);

    // Notifier le parent à chaque changement
    const notifyParent = (left, right, pairs) => {
        if (onChange) {
            onChange(left, right, pairs);
        }
    };

    const addLeftOption = () => {
        const newId = Math.max(...leftOptions.map(opt => opt.id), 0) + 1;
        const newLeftOptions = [...leftOptions, { id: newId, value: '' }];
        setLeftOptions(newLeftOptions);
        notifyParent(newLeftOptions, rightOptions, selectedPairs);
    };

    const addRightOption = () => {
        const newId = Math.max(...rightOptions.map(opt => opt.id), 0) + 1;
        const newRightOptions = [...rightOptions, { id: newId, value: '' }];
        setRightOptions(newRightOptions);
        notifyParent(leftOptions, newRightOptions, selectedPairs);
    };

    const removeLeftOption = (id) => {
        if (leftOptions.length > 2) {
            const newLeftOptions = leftOptions.filter(opt => opt.id !== id);
            setLeftOptions(newLeftOptions);
            const newPairs = { ...selectedPairs };
            delete newPairs[id];
            setSelectedPairs(newPairs);
            notifyParent(newLeftOptions, rightOptions, newPairs);
        }
    };

    const removeRightOption = (id) => {
        if (rightOptions.length > 2) {
            const newRightOptions = rightOptions.filter(opt => opt.id !== id);
            setRightOptions(newRightOptions);
            const newPairs = { ...selectedPairs };
            for (let key in newPairs) {
                if (newPairs[key] === id) {
                    delete newPairs[key];
                }
            }
            setSelectedPairs(newPairs);
            notifyParent(leftOptions, newRightOptions, newPairs);
        }
    };

    const updateLeftOption = (id, value) => {
        const newLeftOptions = leftOptions.map(opt =>
            opt.id === id ? { ...opt, value } : opt
        );
        setLeftOptions(newLeftOptions);
        notifyParent(newLeftOptions, rightOptions, selectedPairs);
    };

    const updateRightOption = (id, value) => {
        const newRightOptions = rightOptions.map(opt =>
            opt.id === id ? { ...opt, value } : opt
        );
        setRightOptions(newRightOptions);
        notifyParent(leftOptions, newRightOptions, selectedPairs);
    };

    const handlePairSelect = (leftId, rightId) => {
        if (!rightId) {
            const newPairs = { ...selectedPairs };
            delete newPairs[leftId];
            setSelectedPairs(newPairs);
            notifyParent(leftOptions, rightOptions, newPairs);
            return;
        }

        const newPairs = { ...selectedPairs };
        const rightInUse = Object.values(newPairs).includes(parseInt(rightId));
        if (rightInUse) {
            for (let key in newPairs) {
                if (newPairs[key] === parseInt(rightId)) {
                    delete newPairs[key];
                    break;
                }
            }
        }
        newPairs[leftId] = parseInt(rightId);
        setSelectedPairs(newPairs);
        notifyParent(leftOptions, rightOptions, newPairs);
    };

    return (
        <>
            <style>{`
                .correspondance-container {
                    background: #f8f9fa;
                    padding: 15px;
                    border-radius: 5px;
                    border: 1px solid #e9ecef;
                    margin-top: 10px;
                }

                .correspondance-mapping {
                    background: white;
                    border-radius: 5px;
                    border: 1px solid #dee2e6;
                }

                .correspondance-mapping .form-group {
                    padding: 8px 12px;
                    border-bottom: 1px solid #f1f3f5;
                    margin-bottom: 0 !important;
                }

                .correspondance-mapping .form-group:last-child {
                    border-bottom: none;
                }

                .correspondance-container .btn-sm {
                    padding: 0.25rem 0.5rem;
                    font-size: 0.875rem;
                    line-height: 1.5;
                    border-radius: 0.2rem;
                }

                .correspondance-container .form-control {
                    margin-right: 5px;
                }

                .correspondance-container .btn {
                    margin-left: 3px;
                }

                .correspondance-container .btn-group {
                    display: flex;
                    gap: 3px;
                    margin-left: 5px;
                }

                .type-selector {
                    border-left: 3px solid #1ab394;
                    background: #f8f9fa;
                    padding: 8px 12px;
                    border-radius: 4px;
                }
            `}</style>

            <div className="correspondance-container">
                <div className="row">
                    <div className="col-sm-6">
                        <h5 className="text-center">Items à associer</h5>
                        {leftOptions.map((option, index) => (
                            <div key={option.id} className="form-group d-flex align-items-center mb-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Item ${index + 1}`}
                                    value={option.value}
                                    onChange={(e) => updateLeftOption(option.id, e.target.value)}
                                />
                                <div className="btn-group">
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeLeftOption(option.id)}
                                        disabled={leftOptions.length <= 2}
                                    >
                                        <i className="fa fa-minus"></i>
                                    </button>
                                    {index === leftOptions.length - 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            onClick={addLeftOption}
                                        >
                                            <i className="fa fa-plus"></i>
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="col-sm-6">
                        <h5 className="text-center">Correspondances</h5>
                        {rightOptions.map((option, index) => (
                            <div key={option.id} className="form-group d-flex align-items-center mb-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Correspondance ${index + 1}`}
                                    value={option.value}
                                    onChange={(e) => updateRightOption(option.id, e.target.value)}
                                />
                                <div className="btn-group">
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeRightOption(option.id)}
                                        disabled={rightOptions.length <= 2}
                                    >
                                        <i className="fa fa-minus"></i>
                                    </button>
                                    {index === rightOptions.length - 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            onClick={addRightOption}
                                        >
                                            <i className="fa fa-plus"></i>
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <h5 className="text-center">Établir les correspondances</h5>
                        <div className="correspondance-mapping border p-3">
                            {leftOptions.map((leftOpt) => {
                                const currentPair = selectedPairs[leftOpt.id] || '';
                                return (
                                    <div key={leftOpt.id} className="form-group d-flex align-items-center mb-2">
                                        <span className="mr-2 font-weight-bold" style={{ minWidth: '120px' }}>
                                            {leftOpt.value || `Item ${leftOptions.indexOf(leftOpt) + 1}`}
                                        </span>
                                        <span className="mx-2">→</span>
                                        <select
                                            className="form-control"
                                            value={currentPair}
                                            onChange={(e) => handlePairSelect(leftOpt.id, e.target.value)}
                                        >
                                            <option value="">Sélectionner une correspondance</option>
                                            {rightOptions.map((rightOpt) => {
                                                const isUsed = Object.entries(selectedPairs).some(
                                                    ([key, value]) => value === rightOpt.id && parseInt(key) !== leftOpt.id
                                                );
                                                return (
                                                    <option
                                                        key={rightOpt.id}
                                                        value={rightOpt.id}
                                                        disabled={isUsed && currentPair !== rightOpt.id}
                                                    >
                                                        {rightOpt.value || `Correspondance ${rightOptions.indexOf(rightOpt) + 1}`}
                                                        {isUsed && currentPair !== rightOpt.id && ' (déjà utilisée)'}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="mt-2  text-muted small">
                    <i className="mr-2 fa fa-info-circle"></i>
                    Chaque correspondance ne peut être utilisée qu'une seule fois
                </div>
            </div>
        </>
    );
};

const Modifier_qcm = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const user_id = localStorage.getItem('user_id');
    const { qcm_id } = location.state || {};
    const { qcm_ref } = location.state || {};
    const [domainesFr, setDomainesFr] = useState([]); // Pour stocker les domaines
    const [domainesEn, setDomainesEn] = useState([]); // Pour stocker les domaines
    const [groupeProcessusFr, setGroupeProcessusFr] = useState([]); // Pour stocker les domaines
    const [groupeProcessusEn, setGroupeProcessusEn] = useState([]); // Pour stocker les domaines
    const [tags, setTags] = useState([]); // Pour stocker les tag
    const [selectedTags, setSelectedTags] = useState([]); // Pour stocker les tags sélectionnés
    const [restriction, setRestriction] = useState('');
    const [alert, setAlert] = useState({ message: '', type: '' });

    const [questionFr, setQuestionFr] = useState('');
    const [tag, setTag] = useState([]);
    const [statut, setStatut] = useState('');
    const [ref, setRef] = useState('');
    const [approcheFr, setApprocheFr] = useState('');
    const [optionAFr, setOptionAFr] = useState('');
    const [optionBFr, setOptionBFr] = useState('');
    const [optionCFr, setOptionCFr] = useState('');
    const [optionDFr, setOptionDFr] = useState('');
    const [optionEFr, setOptionEFr] = useState('');
    const [optionFFr, setOptionFFr] = useState('');
    const [optionGFr, setOptionGFr] = useState('');
    const [optionHFr, setOptionHFr] = useState('');
    const [reponseFr, setReponseFr] = useState([]);
    const [explicationFr, setExplicationFr] = useState('');
    const [niveauFr, setNiveauFr] = useState('');
    const [domaineFr, setDomaineFr] = useState('');
    const [groupeFr, setGroupeFr] = useState('');
    const [sourceFr, setSourceFr] = useState('');
    const [rattacheFr, setRattacheFr] = useState(false);
    const [ecoFr, setEcoFr] = useState(false);
    // alert(tag)

    const [questionEn, setQuestionEn] = useState(''); // Question
    const [approcheEn, setApprocheEn] = useState('');
    const [optionAEn, setOptionAEn] = useState(''); // Option A
    const [optionBEn, setOptionBEn] = useState(''); // Option B
    const [optionCEn, setOptionCEn] = useState(''); // Option C
    const [optionDEn, setOptionDEn] = useState(''); // Option D
    const [optionEEn, setOptionEEn] = useState('');
    const [optionFEn, setOptionFEn] = useState('');
    const [optionGEn, setOptionGEn] = useState('');
    const [optionHEn, setOptionHEn] = useState('');
    const [reponseEn, setReponseEn] = useState([]); // Correct answer
    const [refEn, setRefEn] = useState('');
    const [explicationEn, setExplicationEn] = useState(''); // Explanation
    const [niveauEn, setNiveauEn] = useState(''); // Difficulty level
    const [domaineEn, setDomaineEn] = useState(''); // Knowledge domain
    const [groupeEn, setGroupeEn] = useState(''); // Process group
    const [sourceEn, setSourceEn] = useState(''); // Source
    const [rattacheEn, setRattacheEn] = useState(false); // Link to course material
    const [ecoEn, setEcoEn] = useState(false);

    const [typeQuestionFr, setTypeQuestionFr] = useState('defaut');
    const [typeQuestionEn, setTypeQuestionEn] = useState('defaut');
    const [correspondanceFr, setCorrespondanceFr] = useState({});
    const [correspondanceEn, setCorrespondanceEn] = useState({});
    const [leftOptionsFr, setLeftOptionsFr] = useState([]);
    const [rightOptionsFr, setRightOptionsFr] = useState([]);
    const [leftOptionsEn, setLeftOptionsEn] = useState([]);
    const [rightOptionsEn, setRightOptionsEn] = useState([]);

    // États pour la mise en situation
    const [situations, setSituations] = useState([]);
    const [hasSituationFr, setHasSituationFr] = useState('non');
    const [situationFr, setSituationFr] = useState('');
    const [hasSituationEn, setHasSituationEn] = useState('non');
    const [situationEn, setSituationEn] = useState('');

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Modifier QCM";
        }
    }, [user_id, qcm_id]);

    const options = [
        { value: "A", label: "A" },
        { value: "B", label: "B" },
        { value: "C", label: "C" },
        { value: "D", label: "D" },
        { value: "E", label: "E" },
        { value: "F", label: "F" },
        { value: "G", label: "G" },
        { value: "H", label: "H" },
    ];

    const handleChangeReponseEn = (selectedOptions) => {
        setReponseEn(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };
    const handleChangeReponseFr = (selectedOptions) => {
        setReponseFr(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    const restrictions = [
        { value: "Simulateur", label: "Simulateur" },
        { value: "Examen_blanc", label: "Examen blanc" },
        { value: "Evaluation", label: "Evaluation" },
        { value: "Etude_de_cas", label: "Etude de cas" },
    ];

    const parseTags = (tagData) => {
        if (!tagData) return [];
        if (Array.isArray(tagData)) return tagData;
        if (typeof tagData === 'string') {
            try {
                const parsed = JSON.parse(tagData.replace(/'/g, '"'));
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return tagData.split(',')
                    .map(item => item.trim().replace(/^['"]|['"]$/g, ''))
                    .filter(item => item);
            }
        }
        return [];
    };

    const handleChangeRestriction = (selectedOptions) => {
        setRestriction(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    // Fonction pour récupérer les situations
    const fetchSituations = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-situation/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (response.ok) {
                const data = await response.json();
                setSituations(data);
            } else {
                console.error('Erreur lors de la récupération des situations');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    // Dans fetchQCMFrData
    useEffect(() => {
    const fetchQCMFrData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/qcm-fr-info/${encodeURIComponent(qcm_ref)}/`);
            if (!response.ok) throw new Error('Erreur lors de la récupération des données');
            const data = await response.json();

            // AFFICHER LES DONNÉES RÉCUPÉRÉES DANS LA CONSOLE
            console.log('=== DONNÉES QCM FR ===');
            console.log('Données complètes :', data);
            console.log('type_question :', data.type_question);
            console.log('option1 :', data.option1);
            console.log('option2 :', data.option2);
            console.log('reponse :', data.reponse);

            // Champs communs
            setQuestionFr(data.question);
            setApprocheFr(data.approche);
            setOptionAFr(data.option1 || '');
            setOptionBFr(data.option2 || '');
            setOptionCFr(data.option3 || '');
            setOptionDFr(data.option4 || '');
            setOptionEFr(data.option5 || '');
            setOptionFFr(data.option6 || '');
            setOptionGFr(data.option7 || '');
            setOptionHFr(data.option8 || '');
            setNiveauFr(data.niveau);
            setDomaineFr(data.domaine);
            setGroupeFr(data.groupe_processus);
            setSourceFr(data.source);
            setExplicationFr(data.explication);
            setRattacheFr(data.rattache);
            setEcoFr(data.eco);
            setStatut(data.statut);
            setRef(data.ref);
            setRestriction(data.restriction);

            // Récupérer le type de question
            setTypeQuestionFr(data.type_question || 'defaut');

            // Récupérer les données de mise en situation
            setHasSituationFr(data.has_situation || 'non');
            setSituationFr(data.situation_id || '');

            const parsedTag = parseTags(data.tag);
            setTag(parsedTag);
            console.log('Tag parsé :', parsedTag);

            if (data.type_question === 'correspondance') {
                console.log('✅ Type correspondance détecté !');
                try {
                    let leftOpts = [];
                    let option1Str = data.option1 || '[]';
                    if (typeof option1Str === 'string') {
                        try {
                            if (option1Str.startsWith('"') && option1Str.endsWith('"')) {
                                option1Str = option1Str.slice(1, -1);
                            }
                            option1Str = option1Str.replace(/""/g, '"');
                            leftOpts = JSON.parse(option1Str);
                            if (!Array.isArray(leftOpts)) leftOpts = [];
                        } catch (e) {
                            console.error('Erreur parsing option1:', e);
                            leftOpts = [];
                        }
                    }

                    let rightOpts = [];
                    let option2Str = data.option2 || '[]';
                    if (typeof option2Str === 'string') {
                        try {
                            if (option2Str.startsWith('"') && option2Str.endsWith('"')) {
                                option2Str = option2Str.slice(1, -1);
                            }
                            option2Str = option2Str.replace(/""/g, '"');
                            rightOpts = JSON.parse(option2Str);
                            if (!Array.isArray(rightOpts)) rightOpts = [];
                        } catch (e) {
                            console.error('Erreur parsing option2:', e);
                            rightOpts = [];
                        }
                    }

                    let pairs = {};
                    const reponseData = data.reponse || [];

                    if (Array.isArray(reponseData) && reponseData.length > 0) {
                        try {
                            let joinedStr = reponseData.join('');
                            console.log('joinedStr avant nettoyage:', joinedStr);
                            
                            joinedStr = joinedStr.replace(/""/g, '"');
                            
                            if (joinedStr.startsWith('"') && joinedStr.endsWith('"')) {
                                joinedStr = joinedStr.slice(1, -1);
                            }
                            
                            joinedStr = joinedStr.replace(/}"(\d+)":/g, '}, "$1":');
                            joinedStr = joinedStr.replace(/,+/g, ',');
                            joinedStr = joinedStr.replace(/^,/, '');
                            joinedStr = joinedStr.replace(/,\s*}/g, '}');
                            
                            if (!joinedStr.startsWith('{')) {
                                joinedStr = '{' + joinedStr;
                            }
                            if (!joinedStr.endsWith('}')) {
                                joinedStr = joinedStr + '}';
                            }
                            
                            console.log('joinedStr après nettoyage:', joinedStr);
                            
                            const parsed = JSON.parse(joinedStr);
                            if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                                pairs = parsed;
                            }
                        } catch (e) {
                            console.error('Erreur parsing reponse (tableau):', e);
                            try {
                                const tempPairs = {};
                                let fullStr = reponseData.join('');
                                fullStr = fullStr.replace(/""/g, '"');
                                const regex = /"(\d+)":\s*(\d+)/g;
                                let match;
                                while ((match = regex.exec(fullStr)) !== null) {
                                    tempPairs[parseInt(match[1])] = parseInt(match[2]);
                                }
                                console.log('pairs extraites (regex globale) :', tempPairs);
                                if (Object.keys(tempPairs).length > 0) {
                                    pairs = tempPairs;
                                }
                            } catch (e2) {
                                console.error('Erreur parsing reponse (alternative):', e2);
                            }
                        }
                    } else if (typeof reponseData === 'string') {
                        try {
                            let cleaned = reponseData.replace(/""/g, '"');
                            if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
                                cleaned = cleaned.slice(1, -1);
                            }
                            const parsed = JSON.parse(cleaned);
                            if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                                pairs = parsed;
                            }
                        } catch (e) {
                            console.error('Erreur parsing reponse (string):', e);
                        }
                    } else if (typeof reponseData === 'object' && !Array.isArray(reponseData)) {
                        pairs = reponseData;
                    }

                    console.log('leftOpts final :', leftOpts);
                    console.log('rightOpts final :', rightOpts);
                    console.log('pairs final :', pairs);

                    const formattedLeft = leftOpts.map(item => ({
                        id: Number(item.id),
                        value: item.value || ''
                    }));

                    const formattedRight = rightOpts.map(item => ({
                        id: Number(item.id),
                        value: item.value || ''
                    }));

                    const formattedPairs = {};
                    Object.keys(pairs).forEach(key => {
                        formattedPairs[Number(key)] = Number(pairs[key]);
                    });

                    console.log('formattedPairs final :', formattedPairs);

                    if (formattedLeft.length > 0 && formattedRight.length > 0 && Object.keys(formattedPairs).length > 0) {
                        setLeftOptionsFr(formattedLeft);
                        setRightOptionsFr(formattedRight);
                        setCorrespondanceFr(formattedPairs);
                    } else {
                        setLeftOptionsFr([{ id: 1, value: '' }, { id: 2, value: '' }]);
                        setRightOptionsFr([{ id: 1, value: '' }, { id: 2, value: '' }]);
                        setCorrespondanceFr({});
                    }

                    setReponseFr([]);
                } catch (e) {
                    console.error('Erreur parsing correspondance:', e);
                    setLeftOptionsFr([{ id: 1, value: '' }, { id: 2, value: '' }]);
                    setRightOptionsFr([{ id: 1, value: '' }, { id: 2, value: '' }]);
                    setCorrespondanceFr({});
                }
            } else {
                console.log('❌ Type par défaut');
                setReponseFr(Array.isArray(data.reponse) ? data.reponse : []);
            }

        } catch (error) {
            console.error("Erreur lors de la récupération des données :", error);
        }
    };

    fetchQCMFrData();
    }, [qcm_ref]);



    useEffect(() => {
    const fetchQCMEnData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/qcm-en-info/${encodeURIComponent(qcm_ref)}/`);
            if (!response.ok) throw new Error('Erreur lors de la récupération des données');
            const data = await response.json();

            // Champs communs
            setQuestionEn(data.question);
            setApprocheEn(data.approche);
            setOptionAEn(data.option1 || '');
            setOptionBEn(data.option2 || '');
            setOptionCEn(data.option3 || '');
            setOptionDEn(data.option4 || '');
            setOptionEEn(data.option5 || '');
            setOptionFEn(data.option6 || '');
            setOptionGEn(data.option7 || '');
            setOptionHEn(data.option8 || '');
            setNiveauEn(data.niveau);
            setDomaineEn(data.domaine);
            setGroupeEn(data.groupe_processus);
            setSourceEn(data.source);
            setExplicationEn(data.explication);
            setRattacheEn(data.rattache);
            setEcoEn(data.eco);
            setStatut(data.statut);
            setRefEn(data.ref);
            setRestriction(data.restriction);

            // Récupérer le type de question
            setTypeQuestionEn(data.type_question || 'defaut');

            // Récupérer les données de mise en situation
            setHasSituationEn(data.has_situation || 'non');
            setSituationEn(data.situation_id || '');

            if (data.type_question === 'correspondance') {
                try {
                    let leftOpts = [];
                    let option1Str = data.option1 || '[]';
                    if (typeof option1Str === 'string') {
                        if (option1Str.startsWith('"') && option1Str.endsWith('"')) {
                            option1Str = option1Str.slice(1, -1);
                        }
                        option1Str = option1Str.replace(/""/g, '"');
                        try {
                            leftOpts = JSON.parse(option1Str);
                            if (!Array.isArray(leftOpts)) leftOpts = [];
                        } catch (e) {
                            leftOpts = [];
                        }
                    }

                    let rightOpts = [];
                    let option2Str = data.option2 || '[]';
                    if (typeof option2Str === 'string') {
                        if (option2Str.startsWith('"') && option2Str.endsWith('"')) {
                            option2Str = option2Str.slice(1, -1);
                        }
                        option2Str = option2Str.replace(/""/g, '"');
                        try {
                            rightOpts = JSON.parse(option2Str);
                            if (!Array.isArray(rightOpts)) rightOpts = [];
                        } catch (e) {
                            rightOpts = [];
                        }
                    }

                    let pairs = {};
                    const reponseData = data.reponse || [];

                    if (Array.isArray(reponseData) && reponseData.length > 0) {
                        try {
                            let joinedStr = reponseData.join('');
                            console.log('joinedStr avant nettoyage:', joinedStr);
                            
                            joinedStr = joinedStr.replace(/""/g, '"');
                            
                            if (joinedStr.startsWith('"') && joinedStr.endsWith('"')) {
                                joinedStr = joinedStr.slice(1, -1);
                            }
                            
                            joinedStr = joinedStr.replace(/}"(\d+)":/g, '}, "$1":');
                            joinedStr = joinedStr.replace(/,+/g, ',');
                            joinedStr = joinedStr.replace(/^,/, '');
                            joinedStr = joinedStr.replace(/,\s*}/g, '}');
                            
                            if (!joinedStr.startsWith('{')) {
                                joinedStr = '{' + joinedStr;
                            }
                            if (!joinedStr.endsWith('}')) {
                                joinedStr = joinedStr + '}';
                            }
                            
                            console.log('joinedStr après nettoyage:', joinedStr);
                            
                            const parsed = JSON.parse(joinedStr);
                            if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                                pairs = parsed;
                            }
                        } catch (e) {
                            console.error('Erreur parsing reponse (tableau):', e);
                            try {
                                const tempPairs = {};
                                let fullStr = reponseData.join('');
                                fullStr = fullStr.replace(/""/g, '"');
                                const regex = /"(\d+)":\s*(\d+)/g;
                                let match;
                                while ((match = regex.exec(fullStr)) !== null) {
                                    tempPairs[parseInt(match[1])] = parseInt(match[2]);
                                }
                                console.log('pairs extraites (regex globale) :', tempPairs);
                                if (Object.keys(tempPairs).length > 0) {
                                    pairs = tempPairs;
                                }
                            } catch (e2) {
                                console.error('Erreur parsing reponse (alternative):', e2);
                            }
                        }
                    } else if (typeof reponseData === 'string') {
                        try {
                            let cleaned = reponseData.replace(/""/g, '"');
                            if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
                                cleaned = cleaned.slice(1, -1);
                            }
                            const parsed = JSON.parse(cleaned);
                            if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                                pairs = parsed;
                            }
                        } catch (e) {
                            console.error('Erreur parsing reponse EN (string):', e);
                        }
                    } else if (typeof reponseData === 'object' && !Array.isArray(reponseData)) {
                        pairs = reponseData;
                    }

                    const formattedLeft = leftOpts.map(item => ({
                        id: Number(item.id),
                        value: item.value || ''
                    }));

                    const formattedRight = rightOpts.map(item => ({
                        id: Number(item.id),
                        value: item.value || ''
                    }));

                    const formattedPairs = {};
                    Object.keys(pairs).forEach(key => {
                        formattedPairs[Number(key)] = Number(pairs[key]);
                    });

                    if (formattedLeft.length > 0 && formattedRight.length > 0 && Object.keys(formattedPairs).length > 0) {
                        setLeftOptionsEn(formattedLeft);
                        setRightOptionsEn(formattedRight);
                        setCorrespondanceEn(formattedPairs);
                    } else {
                        setLeftOptionsEn([{ id: 1, value: '' }, { id: 2, value: '' }]);
                        setRightOptionsEn([{ id: 1, value: '' }, { id: 2, value: '' }]);
                        setCorrespondanceEn({});
                    }

                    setReponseEn([]);
                } catch (e) {
                    console.error('Erreur parsing correspondance EN:', e);
                    setLeftOptionsEn([{ id: 1, value: '' }, { id: 2, value: '' }]);
                    setRightOptionsEn([{ id: 1, value: '' }, { id: 2, value: '' }]);
                    setCorrespondanceEn({});
                }
            } else {
                setReponseEn(Array.isArray(data.reponse) ? data.reponse : []);
            }

        } catch (error) {
            console.error("Erreur lors de la récupération des données EN:", error);
        }
    };

    fetchQCMEnData();
    }, [qcm_ref]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validation selon le type
        if (typeQuestionFr === 'defaut') {
            if (!ref) {
                showAlert('Champs Référence obligatoire', 'danger');
                return;
            }
            if (!questionFr) {
                showAlert('Champs question obligatoire', 'danger');
                return;
            }
            if (!optionAFr || !optionBFr) {
                showAlert('Veuillez renseigner au moins deux options', 'danger');
                return;
            }
            if (!reponseFr || (Array.isArray(reponseFr) && reponseFr.length === 0)) {
                showAlert('Champs réponse obligatoire', 'danger');
                return;
            }
            if (!tag || (Array.isArray(tag) && tag.length === 0)) {
                showAlert('Tag obligatoire', 'danger');
                return;
            }
        } else if (typeQuestionFr === 'correspondance') {
            if (!ref) {
                showAlert('Champs Référence obligatoire', 'danger');
                return;
            }
            if (!questionFr) {
                showAlert('Champs question obligatoire', 'danger');
                return;
            }
            if (!tag || (Array.isArray(tag) && tag.length === 0)) {
                showAlert('Tag obligatoire', 'danger');
                return;
            }

            const hasEmptyLeft = leftOptionsFr.some(opt => !opt.value.trim());
            const hasEmptyRight = rightOptionsFr.some(opt => !opt.value.trim());
            if (hasEmptyLeft || hasEmptyRight) {
                showAlert('Veuillez remplir tous les items et correspondances', 'danger');
                return;
            }
            const leftIds = leftOptionsFr.map(opt => opt.id);
            const allPaired = leftIds.every(id => correspondanceFr[id] !== undefined);
            if (!allPaired) {
                showAlert('Veuillez établir toutes les correspondances', 'danger');
                return;
            }
        }

        // Validation de la mise en situation
        if (hasSituationFr === 'oui' && !situationFr) {
            showAlert('Veuillez sélectionner une mise en situation', 'danger');
            return;
        }

        // Création des données françaises
        const dataFr = {
            question: questionFr,
            tag: tag,
            approche: approcheFr,
            explication: explicationFr,
            niveau: niveauFr,
            domaine: domaineFr,
            groupeFr: groupeFr,
            source: sourceFr,
            rattache: rattacheFr,
            eco: ecoFr,
            statut: statut,
            ref: ref,
            restriction: restriction,
            type_question: typeQuestionFr,
            has_situation: hasSituationFr,
            situation_id: hasSituationFr === 'oui' ? situationFr : null,
        };

        if (typeQuestionFr === 'defaut') {
            dataFr.optionAFr = optionAFr;
            dataFr.optionBFr = optionBFr;
            dataFr.optionCFr = optionCFr;
            dataFr.optionDFr = optionDFr;
            dataFr.optionEFr = optionEFr;
            dataFr.optionFFr = optionFFr;
            dataFr.optionGFr = optionGFr;
            dataFr.optionHFr = optionHFr;
            dataFr.reponse = reponseFr;
            dataFr.correspondance = null;
        } else {
            dataFr.correspondance = JSON.stringify({
                leftOptions: leftOptionsFr,
                rightOptions: rightOptionsFr,
                pairs: correspondanceFr
            });
            dataFr.reponse = correspondanceFr;
            dataFr.optionAFr = '';
            dataFr.optionBFr = '';
            dataFr.optionCFr = '';
            dataFr.optionDFr = '';
            dataFr.optionEFr = '';
            dataFr.optionFFr = '';
            dataFr.optionGFr = '';
            dataFr.optionHFr = '';
        }

        // Création des données anglaises
        const dataEn = {
            questionEn: questionEn,
            tag: tag,
            approcheEn: approcheEn,
            explicationEn: explicationEn,
            niveauEn: niveauEn,
            domaineEn: domaineEn,
            groupeEn: groupeEn,
            sourceEn: sourceEn,
            rattacheEn: rattacheEn,
            ecoEn: ecoEn,
            statut: statut,
            ref: refEn,
            restriction: restriction,
            type_question: typeQuestionEn,
            has_situation: hasSituationEn,
            situation_id: hasSituationEn === 'oui' ? situationEn : null,
        };

        if (typeQuestionEn === 'defaut') {
            dataEn.optionAEn = optionAEn;
            dataEn.optionBEn = optionBEn;
            dataEn.optionCEn = optionCEn;
            dataEn.optionDEn = optionDEn;
            dataEn.optionEEn = optionEEn;
            dataEn.optionFEn = optionFEn;
            dataEn.optionGEn = optionGEn;
            dataEn.optionHEn = optionHEn;
            dataEn.reponseEn = reponseEn;
            dataEn.correspondance = null;
        } else {
            dataEn.correspondance = JSON.stringify({
                leftOptions: leftOptionsEn,
                rightOptions: rightOptionsEn,
                pairs: correspondanceEn
            });
            dataEn.reponseEn = correspondanceEn;
            dataEn.optionAEn = '';
            dataEn.optionBEn = '';
            dataEn.optionCEn = '';
            dataEn.optionDEn = '';
            dataEn.optionEEn = '';
            dataEn.optionFEn = '';
            dataEn.optionGEn = '';
            dataEn.optionHEn = '';
        }

        try {
            const responseFr = await fetch(`${process.env.REACT_APP_HOTE}/modifier-qcm-fr/${qcm_ref}/${user_id}/`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(dataFr),
            });

            let responseEnOk = true;
            if (questionEn) {
                const responseEn = await fetch(`${process.env.REACT_APP_HOTE}/modifier-qcm-en/${qcm_ref}/${user_id}/`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(dataEn),
                });
                responseEnOk = responseEn.ok;
            }

            if (responseFr.ok && responseEnOk) {
                showAlert('Modification effectuée avec succès');
                navigate('/Liste-qcm');
            } else {
                const errorData = await responseFr.json();
                showAlert(errorData.error || 'Erreur lors de la modification', 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Une erreur est survenue', 'danger');
        }
    };


    const handleCancel = () => {
        navigate('/Liste-qcm');
    };

    const fetchDomaines = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/Liste-domaine/');
            if (response.ok) {
                const data = await response.json();
                setDomainesFr(data);
            }
        } catch (error) {
        }
    };

    const [ecos, setEcos] = useState([]);
    const fetchEcos = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-eco/');
            if (response.ok) {
                const data = await response.json();
                setEcos(data);
            } else {
                console.error('Erreur lors de la récupération des ecos');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };
    const fetchGroupeProcessus = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/listes-groupes-processus/');
            if (response.ok) {
                const data = await response.json();
                setGroupeProcessusFr(data);
            } else {
                console.error('Erreur lors de la récupération des groupes processus');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {
        fetchDomaines();
        fetchGroupeProcessus();
        fetchEcos();
        fetchSituations();
    }, []);




    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    }


    useEffect(() => {
        const fetchTags = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + '/liste-tag/');
                if (response.ok) {
                    const data = await response.json();
                    setTags(data);
                }
            } catch (error) {
            }
        };

        fetchTags();
    }, []);

    const [currentQCMRef, setCurrentQCMRef] = useState(Number(qcm_ref) || 1);

    const handleIncrement = () => {
        setCurrentQCMRef(prev => prev + 1);
        navigate(`/Modifier-qcm`, { state: { qcm_ref: currentQCMRef + 1 } });
        setAlert({ message: '', type: '' });
    };

    const handleDecrement = () => {
        if (currentQCMRef > 1) {
            setCurrentQCMRef(prev => prev - 1);
            navigate(`/Modifier-qcm`, { state: { qcm_ref: currentQCMRef - 1 } });
            setAlert({ message: '', type: '' });
        }
    };



    // Gérer la sélection des tags
    const handleSelectChange = (e) => {
        const options = e.target.options;
        const selected = [];

        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selected.push(options[i].value);
            }
        }

        setTag((prevTags) => {
            const updatedTags = Array.isArray(prevTags) ? prevTags : [];
            return [...new Set([...updatedTags, ...selected])];
        });
    };



    // Fonction pour supprimer un tag sélectionné
    const removeTag = (tagToRemove) => {
        setTag((prevTags) => {
            if (!Array.isArray(prevTags)) {
                console.warn("prevTags n'est pas un tableau", prevTags);
                return [];
            }
            if (prevTags.length === 0) return prevTags;
            return prevTags.filter(tag => tag !== tagToRemove);
        });
    };


    // Analyser les tags pour affichage ou autres manipulations
    const parsedTags = (() => {
        try {
            if (Array.isArray(tag)) return tag;
            if (typeof tag === 'string' && tag.startsWith('[')) {
                return JSON.parse(tag.replace(/'/g, '"'));
            }
            return tag.split(',')
                .map(item => item.trim().replace(/^["']|["']$/g, ''))
                .filter(item => item !== '');
        } catch (e) {
            console.error("Erreur de parsing des tags:", e);
            return [];
        }
    })();


    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaRegQuestionCircle size={25} className='mr-2' /> Modifier QCM</h2>
                            <small>Administration des QCMs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-qcm`}>QCM</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Modifier-qcm?id=${qcm_id}`}>Modifier QCM</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>



                    {alert.message && (
                        <div className={`alert alert-${alert.type} row justify-content-between position-relative m-3`}>
                            <div
                                dangerouslySetInnerHTML={{ __html: alert.message }}
                            />

                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}

                    <div className="col-lg-12 mt-4 wrapper wrapper-content animated fadeInRight">
                        <div className="ibox">
                            <div className="ibox-title d-flex justify-content-between align-items-center p-3">
                                <div className="d-flex align-items-center gap-2">
                                    <button onClick={handleDecrement} className="btn btn-succes">
                                        <FaArrowLeft />
                                    </button>
                                    <span className="badge badge-success ml-2">{statut}</span>
                                    {parsedTags.map((item, index) => (
                                        <span key={index} className="badge badge-success ml-1">
                                            {item}
                                        </span>
                                    ))}
                                </div>
                                <button onClick={handleIncrement} className="btn btn-succes">
                                    <FaArrowRight />
                                </button>
                            </div>

                            <div className="ibox-content">
                                <div className="row">
                                    <div className="col-sm-6 b-r">
                                        <form onSubmit={handleSubmit} id="qcmForm1" method="post">
                                            <div className="panel-body">
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="ref"><b>référence</b></label>
                                                    <input
                                                        type="text"
                                                        name="ref"
                                                        id="ref"
                                                        placeholder="Entrez la référence"
                                                        className="form-control"
                                                        value={ref}
                                                        onChange={(e) => setRef(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group type-selector">
                                                    <label className="control-label"><b>Type de question</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="typeQuestionFr"
                                                        id="typeQuestionFr"
                                                        value={typeQuestionFr}
                                                        onChange={(e) => setTypeQuestionFr(e.target.value)}
                                                    >
                                                        <option value="defaut">Par défaut</option>
                                                        <option value="correspondance">Par correspondance</option>
                                                    </select>
                                                </div>

                                                {/* Nouveau champ Mise en situation - FR */}
                                                <div className="form-group">
                                                    <label className="control-label"><b>Mise en situation</b></label>
                                                    <div className="d-flex align-items-center">
                                                        <div className="mr-4">
                                                            <label className="mr-2">
                                                                <input
                                                                    type="radio"
                                                                    name="hasSituationFr"
                                                                    value="non"
                                                                    checked={hasSituationFr === 'non'}
                                                                    onChange={(e) => {
                                                                        setHasSituationFr(e.target.value);
                                                                        if (e.target.value === 'non') {
                                                                            setSituationFr('');
                                                                        }
                                                                    }}
                                                                />
                                                                {' '}Non
                                                            </label>
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="hasSituationFr"
                                                                    value="oui"
                                                                    checked={hasSituationFr === 'oui'}
                                                                    onChange={(e) => {
                                                                        setHasSituationFr(e.target.value);
                                                                    }}
                                                                />
                                                                {' '}Oui
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Select conditionnel pour les situations - FR */}
                                                {hasSituationFr === 'oui' && (
                                                    <div className="form-group">
                                                        <label className="control-label"><b>Sélectionner une mise en situation</b></label>
                                                        <select
                                                            className="form-control"
                                                            value={situationFr}
                                                            onChange={(e) => setSituationFr(e.target.value)}
                                                        >
                                                            <option value="">Choisissez une mise en situation</option>
                                                            {situations.map((situation) => (
                                                                <option key={situation.id} value={situation.id}>
                                                                    {situation.titre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}

                                                <div className="form-group">
                                                    <input type="hidden" name="qcm_idFr" id="qcm_idFr" className="form-control" />
                                                    <label className="control-label" htmlFor="summernote_question"><b>Question</b></label>

                                                    <SummernoteEditor value={questionFr} onChange={setQuestionFr} />
                                                </div>
                                                {typeQuestionFr === 'defaut' ? (
                                                    <>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option1"><b>Option A</b></label>
                                                            <input
                                                                type="text"
                                                                name="option1Fr"
                                                                id="option1"
                                                                placeholder="Entrez Option A"
                                                                className="form-control"
                                                                value={optionAFr}
                                                                onChange={(e) => setOptionAFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option2"><b>Option B</b></label>
                                                            <input
                                                                type="text"
                                                                name="option2Fr"
                                                                id="option2"
                                                                placeholder="Entrez Option B"
                                                                className="form-control"
                                                                value={optionBFr}
                                                                onChange={(e) => setOptionBFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option3"><b>Option C</b></label>
                                                            <input
                                                                type="text"
                                                                name="option3Fr"
                                                                id="option3"
                                                                placeholder="Entrez Option C"
                                                                className="form-control"
                                                                value={optionCFr}
                                                                onChange={(e) => setOptionCFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option4"><b>Option D</b></label>
                                                            <input
                                                                type="text"
                                                                name="option4Fr"
                                                                id="option4"
                                                                placeholder="Entrez Option D"
                                                                className="form-control"
                                                                value={optionDFr}
                                                                onChange={(e) => setOptionDFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option5"><b>Option E</b></label>
                                                            <input
                                                                type="text"
                                                                name="option5Fr"
                                                                id="option5"
                                                                placeholder="Entrez Option E"
                                                                className="form-control"
                                                                value={optionEFr}
                                                                onChange={(e) => setOptionEFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option6"><b>Option F</b></label>
                                                            <input
                                                                type="text"
                                                                name="option6Fr"
                                                                id="option6"
                                                                placeholder="Entrez Option F"
                                                                className="form-control"
                                                                value={optionFFr}
                                                                onChange={(e) => setOptionFFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option7"><b>Option G</b></label>
                                                            <input
                                                                type="text"
                                                                name="option7Fr"
                                                                id="option7"
                                                                placeholder="Entrez Option G"
                                                                className="form-control"
                                                                value={optionGFr}
                                                                onChange={(e) => setOptionGFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option8"><b>Option H</b></label>
                                                            <input
                                                                type="text"
                                                                name="option8Fr"
                                                                id="option8"
                                                                placeholder="Entrez Option H"
                                                                className="form-control"
                                                                value={optionHFr}
                                                                onChange={(e) => setOptionHFr(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label className="control-label"><b>Reponse</b></label>
                                                            <Select
                                                                options={options}
                                                                isMulti
                                                                value={options.filter(option => {
                                                                    if (Array.isArray(reponseFr)) {
                                                                        return reponseFr.includes(option.value);
                                                                    }
                                                                    return false;
                                                                })}
                                                                onChange={handleChangeReponseFr}
                                                                placeholder="Selectionnez une ou plusieurs réponses"
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <QuestionCorrespondance
                                                        initialLeftOptions={leftOptionsFr}
                                                        initialRightOptions={rightOptionsFr}
                                                        initialPairs={correspondanceFr}
                                                        onChange={(left, right, pairs) => {
                                                            setLeftOptionsFr(left);
                                                            setRightOptionsFr(right);
                                                            setCorrespondanceFr(pairs);
                                                        }}
                                                    />
                                                )}

                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="Explication"><b>Explication</b></label>

                                                    <SummernoteEditor value={explicationFr} onChange={setExplicationFr} />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="niveau"><b>Niveau de difficulté</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="niveauFr"
                                                        id="niveau"
                                                        value={niveauFr}
                                                        onChange={(e) => setNiveauFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionnez le niveau</option>
                                                        <option value="1">Niveau 1</option>
                                                        <option value="2">Niveau 2</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Approche</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="approcheFr"
                                                        id="approche"
                                                        value={approcheFr}
                                                        onChange={(e) => setApprocheFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionnez l'approche</option>
                                                        <option value="Agile">Agile</option>
                                                        <option value="Agnostique">Agnostique</option>
                                                        <option value="Hybride">Hybride</option>
                                                        <option value="Prédictif">Prédictif</option>
                                                        <option value="Tout">Tout</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Domaine de connaissance</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="domaineFr"
                                                        id="domaine"
                                                        value={domaineFr}
                                                        onChange={(e) => setDomaineFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionnez le domaine</option>
                                                        {domainesFr.map((domaine) => (
                                                            <option key={domaine.id} value={domaine.ordre}>
                                                                {domaine.titre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>


                                                <div className="form-group">
                                                    <label><b>Tags</b></label>
                                                    <Select
                                                        isMulti
                                                        options={tags.map((tag) => ({
                                                            value: tag.titre,
                                                            label: tag.titre,
                                                        }))}
                                                        value={Array.isArray(parsedTags) ? parsedTags.map((tag) => ({
                                                            value: tag,
                                                            label: tag,
                                                        })) : []}
                                                        onChange={(selectedOptions) => {
                                                            const selectedTags = selectedOptions.map((option) => option.value);
                                                            setTag(selectedTags);
                                                        }}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Sélectionnez un ou plusieurs tags..."

                                                        styles={{
                                                            multiValue: (base) => ({
                                                                ...base,
                                                                backgroundColor: "#0b5ed7",
                                                                color: "white",
                                                                borderRadius: "5px",
                                                            }),
                                                            multiValueLabel: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                            }),
                                                            multiValueRemove: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                                ':hover': {
                                                                    backgroundColor: "#0b5ed7",
                                                                    color: "white",
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label><b>Groupe de processus</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="groupeFr"
                                                        id="groupe"
                                                        value={groupeFr}
                                                        onChange={(e) => setGroupeFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionnez le groupe</option>
                                                        {groupeProcessusFr.map((groupe_processus) => (
                                                            <option key={groupe_processus.id} value={groupe_processus.ordre}>
                                                                {groupe_processus.titre_fr}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Eco</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="ecoFr"
                                                        id="eco"
                                                        value={ecoFr}
                                                        onChange={(e) => setEcoFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionner un éco</option>
                                                        {ecos.map((eco) => (
                                                            <option key={eco.id} value={eco.ordre}>
                                                                {eco.titre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label className="control-label"><b>Restriction</b></label>
                                                    <Select
                                                        options={restrictions}
                                                        isMulti
                                                        value={restrictions.filter(option => restriction.includes(option.value))}
                                                        onChange={handleChangeRestriction}
                                                        placeholder="Selectionnez une ou plusieurs restrictions"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="source"><b>Source</b></label>
                                                    <input
                                                        type="text"
                                                        name="sourceFr"
                                                        id="source"
                                                        placeholder="Entrez Source"
                                                        className="form-control"
                                                        value={sourceFr}
                                                        onChange={(e) => setSourceFr(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="d-flex align-items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="rattacheFr"
                                                            id="rattache"
                                                            className="i-checks mr-2"
                                                            checked={rattacheFr}
                                                            onChange={(e) => setRattacheFr(e.target.checked)}
                                                        />
                                                        Rattacher aux supports de cours du domaine
                                                    </label>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    <div className="col-sm-6">
                                        <form onSubmit={handleSubmit} id="qcmForm2" method="post">
                                            <div className="panel-body">
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="refEn"><b>reference</b></label>
                                                    <input
                                                        type="text"
                                                        name="refEn"
                                                        id="refEn"
                                                        placeholder="Entrer reference"
                                                        className="form-control"
                                                        value={refEn}
                                                        onChange={(e) => setRefEn(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group type-selector">
                                                    <label className="control-label"><b>Question Type</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="typeQuestionEn"
                                                        id="typeQuestionEn"
                                                        value={typeQuestionEn}
                                                        onChange={(e) => setTypeQuestionEn(e.target.value)}
                                                    >
                                                        <option value="defaut">Default</option>
                                                        <option value="correspondance">Correspondence</option>
                                                    </select>
                                                </div>

                                                {/* Nouveau champ Mise en situation - EN */}
                                                <div className="form-group">
                                                    <label className="control-label"><b>Situation</b></label>
                                                    <div className="d-flex align-items-center">
                                                        <div className="mr-4">
                                                            <label className="mr-2">
                                                                <input
                                                                    type="radio"
                                                                    name="hasSituationEn"
                                                                    value="non"
                                                                    checked={hasSituationEn === 'non'}
                                                                    onChange={(e) => {
                                                                        setHasSituationEn(e.target.value);
                                                                        if (e.target.value === 'non') {
                                                                            setSituationEn('');
                                                                        }
                                                                    }}
                                                                />
                                                                {' '}No
                                                            </label>
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="hasSituationEn"
                                                                    value="oui"
                                                                    checked={hasSituationEn === 'oui'}
                                                                    onChange={(e) => {
                                                                        setHasSituationEn(e.target.value);
                                                                    }}
                                                                />
                                                                {' '}Yes
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Select conditionnel pour les situations - EN */}
                                                {hasSituationEn === 'oui' && (
                                                    <div className="form-group">
                                                        <label className="control-label"><b>Select a situation</b></label>
                                                        <select
                                                            className="form-control"
                                                            value={situationEn}
                                                            onChange={(e) => setSituationEn(e.target.value)}
                                                        >
                                                            <option value="">Choose a situation</option>
                                                            {situations.map((situation) => (
                                                                <option key={situation.id} value={situation.id}>
                                                                    {situation.titre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}

                                                <div className="form-group">
                                                    <input type="hidden" name="qcm_idEn" id="qcm_id" className="form-control" />
                                                    <label className="control-label" htmlFor="summernote_question"><b>Question</b></label>
                                                    <SummernoteEditor value={questionEn} onChange={setQuestionEn} />
                                                </div>
                                                {typeQuestionEn === 'defaut' ? (
                                                    <>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option1"><b>Option A</b></label>
                                                            <input
                                                                type="text"
                                                                name="option1En"
                                                                id="option1"
                                                                placeholder="Enter Option A"
                                                                className="form-control"
                                                                value={optionAEn}
                                                                onChange={(e) => setOptionAEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option2"><b>Option B</b></label>
                                                            <input
                                                                type="text"
                                                                name="option2En"
                                                                id="option2"
                                                                placeholder="Enter Option B"
                                                                className="form-control"
                                                                value={optionBEn}
                                                                onChange={(e) => setOptionBEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option3"><b>Option C</b></label>
                                                            <input
                                                                type="text"
                                                                name="option3En"
                                                                id="option3"
                                                                placeholder="Enter Option C"
                                                                className="form-control"
                                                                value={optionCEn}
                                                                onChange={(e) => setOptionCEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option4"><b>Option D</b></label>
                                                            <input
                                                                type="text"
                                                                name="option4En"
                                                                id="option4"
                                                                placeholder="Enter Option D"
                                                                className="form-control"
                                                                value={optionDEn}
                                                                onChange={(e) => setOptionDEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option5"><b>Option E</b></label>
                                                            <input
                                                                type="text"
                                                                name="option5En"
                                                                id="option5"
                                                                placeholder="Enter Option E"
                                                                className="form-control"
                                                                value={optionEEn}
                                                                onChange={(e) => setOptionEEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option6"><b>Option F</b></label>
                                                            <input
                                                                type="text"
                                                                name="option6En"
                                                                id="option6"
                                                                placeholder="Enter Option F"
                                                                className="form-control"
                                                                value={optionFEn}
                                                                onChange={(e) => setOptionFEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option7"><b>Option G</b></label>
                                                            <input
                                                                type="text"
                                                                name="option7En"
                                                                id="option7"
                                                                placeholder="Enter Option G"
                                                                className="form-control"
                                                                value={optionGEn}
                                                                onChange={(e) => setOptionGEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option8"><b>Option H</b></label>
                                                            <input
                                                                type="text"
                                                                name="option8En"
                                                                id="option8"
                                                                placeholder="Enter Option H"
                                                                className="form-control"
                                                                value={optionHEn}
                                                                onChange={(e) => setOptionHEn(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label className="control-label"><b>Answer</b></label>
                                                            <Select
                                                                options={options}
                                                                isMulti
                                                                value={options.filter(option => {
                                                                    if (Array.isArray(reponseEn)) {
                                                                        return reponseEn.includes(option.value);
                                                                    }
                                                                    return false;
                                                                })}
                                                                onChange={handleChangeReponseEn}
                                                                placeholder="Select one or more answers"
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <QuestionCorrespondance
                                                        initialLeftOptions={leftOptionsEn}
                                                        initialRightOptions={rightOptionsEn}
                                                        initialPairs={correspondanceEn}
                                                        onChange={(left, right, pairs) => {
                                                            setLeftOptionsEn(left);
                                                            setRightOptionsEn(right);
                                                            setCorrespondanceEn(pairs);
                                                        }}
                                                    />
                                                )}

                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="Explication"><b>Explanation</b></label>
                                                    <SummernoteEditor value={explicationEn} onChange={setExplicationEn} />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="niveau"><b>Difficulty Level</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="niveauEn"
                                                        id="niveau"
                                                        value={niveauEn}
                                                        onChange={(e) => setNiveauEn(e.target.value)}
                                                    >
                                                        <option value="">Select level</option>
                                                        <option value="1">Level 1</option>
                                                        <option value="2">Level 2</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Approach</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="approcheEn"
                                                        id="approche"
                                                        value={approcheEn}
                                                        onChange={(e) => setApprocheEn(e.target.value)}
                                                    >
                                                        <option value="">Select an approach</option>
                                                        <option value="Agile">Agile</option>
                                                        <option value="Agnostique">Agnostique</option>
                                                        <option value="Hybride">Hybride</option>
                                                        <option value="Prédictif">Prédictif</option>
                                                        <option value="Tout">Tout</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Knowledge Domain</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="domaineEn"
                                                        id="domaine"
                                                        value={domaineEn}
                                                        onChange={(e) => setDomaineEn(e.target.value)}
                                                    >
                                                        <option value="">Select domain</option>
                                                        {domainesFr.map((domaine) => (
                                                            <option key={domaine.id} value={domaine.ordre}>
                                                                {domaine.titre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label><b>Tags</b></label>
                                                    <Select
                                                        isMulti
                                                        options={tags.map((tag) => ({
                                                            value: tag.titre,
                                                            label: tag.titre,
                                                        }))}
                                                        value={Array.isArray(parsedTags) ? parsedTags.map((tag) => ({
                                                            value: tag,
                                                            label: tag,
                                                        })) : []}
                                                        onChange={(selectedOptions) => {
                                                            const selectedTags = selectedOptions.map((option) => option.value);
                                                            setTag(selectedTags);
                                                        }}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Sélectionnez un ou plusieurs tags..."

                                                        styles={{
                                                            multiValue: (base) => ({
                                                                ...base,
                                                                backgroundColor: "#0b5ed7",
                                                                color: "white",
                                                                borderRadius: "5px",
                                                            }),
                                                            multiValueLabel: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                            }),
                                                            multiValueRemove: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                                ':hover': {
                                                                    backgroundColor: "#0b5ed7",
                                                                    color: "white",
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label><b>Process Group</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="groupeEn"
                                                        id="groupe"
                                                        value={groupeEn}
                                                        onChange={(e) => setGroupeEn(e.target.value)}
                                                    >
                                                        <option value="">Select group</option>
                                                        {groupeProcessusFr.map((groupe_processus) => (
                                                            <option key={groupe_processus.id} value={groupe_processus.ordre}>
                                                                {groupe_processus.titre_fr}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Eco</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="ecoEn"
                                                        id="eco"
                                                        value={ecoEn}
                                                        onChange={(e) => setEcoEn(e.target.value)}
                                                    >
                                                        <option value="">Select eco</option>
                                                        {ecos.map((eco) => (
                                                            <option key={eco.id} value={eco.ordre}>
                                                                {eco.titre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label className="control-label"><b>Restriction</b></label>
                                                    <Select
                                                        options={restrictions}
                                                        isMulti
                                                        value={restrictions.filter(option => restriction.includes(option.value))}
                                                        onChange={handleChangeRestriction}
                                                        placeholder="Selectionnez une ou plusieurs restrictions"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="source"><b>Source</b></label>
                                                    <input
                                                        type="text"
                                                        name="sourceEn"
                                                        id="source"
                                                        placeholder="Enter Source"
                                                        className="form-control"
                                                        value={sourceEn}
                                                        onChange={(e) => setSourceEn(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="d-flex align-items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="rattacheEn"
                                                            id="rattache"
                                                            className="i-checks mr-2 "
                                                            checked={rattacheEn}
                                                            onChange={(e) => setRattacheEn(e.target.checked)}
                                                        />
                                                        Attach to course materials of the domain
                                                    </label>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Statut</b></label>
                                                    <select
                                                        className="form-control m-b w-50"
                                                        name="statut"
                                                        id="statut"
                                                        value={statut}
                                                        onChange={(e) => setStatut(e.target.value)}
                                                    >
                                                        <option value=""></option>
                                                        <option value="En Attente">En Attente</option>
                                                        <option value="Corriger">Corriger</option>
                                                        <option value="Approuvé">Approuvé</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                {/* Boutons de soumission communs */}
                                <div className="ibox-footer text-right m-3">
                                    <Link to="/Liste-qcm" className="btn btn-secondary mr-2">Retour</Link>
                                    <button type="button" className="btn btn-secondary mr-2" onClick={handleCancel}>Annuler</button>
                                    <button type="submit" form="qcmForm1" className="btn btn-success">Enregistrer</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modifier_qcm;